import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AssetImageConfiguration } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';
import { KnowledgeArticle } from '@generated/graphql';
import { LazyAssetComponent } from '../../lazy-image/components/lazy-asset/lazy-asset.component';

@Component({
    selector: 'app-knowledge-read-next',
    templateUrl: './knowledge-read-next.component.html',
    standalone: true,
    imports: [CommonModule, RouterModule, LazyAssetComponent],
})
export class KnowledgeReadNextComponent implements OnChanges {
    @Input() article: KnowledgeArticle | null = null;
    @Input() additionalClasses: string[] = [];

    readNext: KnowledgeArticle | null = null;
    featuredImageConfiguration: AssetImageConfiguration | null = null;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['article']) {
            if (this.article) {
                this.readNext = this.article.readNext || null;

                if (this.readNext?.featuredImageSquare) {
                    this.featuredImageConfiguration = {
                        image: this.readNext.featuredImageSquare,
                        ratioWidth: 1,
                        ratioHeight: 1,
                        width: 1000,
                        width2x: 2000,
                    };
                } else {
                    this.featuredImageConfiguration = null;
                }
            }
        }
    }
}
